import { render, staticRenderFns } from "./clientSmsLog.vue?vue&type=template&id=b39ff814&scoped=true"
import script from "./clientSmsLog.vue?vue&type=script&lang=js"
export * from "./clientSmsLog.vue?vue&type=script&lang=js"
import style0 from "./clientSmsLog.vue?vue&type=style&index=0&id=b39ff814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39ff814",
  null
  
)

export default component.exports